import cacheLs from "../cacheLs"

export default {
  setSPCMFireflies (state, data) {
    state.SPCMFireflies = JSON.stringify(data)
    cacheLs.set_SPCMFireflies(data)
  }
}
